"use client";

import { CALL_TIMES } from "@/features/leads/shared/list-answers";
import { CheckRow } from "@/features/quote/ui/CheckRow";
import { StepHeading } from "@/features/quote/ui/StepHeading";
import { StepNav } from "@/features/quote/ui/StepNav";
import { useWizard } from "@/features/quote/ui/wizard-context";

export function CallTimeStep() {
  const { state, toggle, goToStep, step, stepReady } = useWizard();

  return (
    <section>
      <StepHeading
        title="Hvornår kan du bedst tage telefonen?"
        body="Firmaet ringer dig med et uforpligtende tilbud. Vælg et eller flere tidsrum, så ringer de, når du kan svare."
        maxW="max-w-[24ch]"
      />
      <CheckRow
        options={CALL_TIMES.options}
        values={state.callTimes}
        onToggle={(v) => toggle("callTimes", v)}
      />
      <StepNav
        onBack={() => goToStep(step - 1)}
        onNext={() => goToStep(step + 1)}
        nextEnabled={stepReady("callTime")}
        nextLabel="Næste →"
      />
    </section>
  );
}
